import React from "react"
import PropTypes from "prop-types";

import { PagePlaceHolder } from "./PagePlaceHolder"
import { NavigationPillButton } from "../NavigationPillButton";

const InsidePagePlaceHolder = ({brand, type, length, isFlightOrCruiseTab}) => (
	<>
		{isFlightOrCruiseTab && <NavigationPillButton type={type} brand={brand} isInnerPage={true} />}
		<PagePlaceHolder brand={brand} type={type} length={length} />
	</>
    )

InsidePagePlaceHolder.propTypes = {
    brand: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    length: PropTypes.number.isRequired,
    isFlightOrCruiseTab: PropTypes.bool.isRequired,
};

export { InsidePagePlaceHolder }
export default InsidePagePlaceHolder